const initialState = {
    barcode: '',
    timerTime : 0,
};
const barcode_generate = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_BARCODE_GENERATE_PAGE':
            return {...state, barcode: action.barcode};
        case 'CHANGE_TIMER_TIME_BARCODE_GENERATE_PAGE':
            return {...state, timerTime: action.timerTime};
        default:
            return state;
    }
};

export default barcode_generate;
